import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>About CGH</h4>
          <p>Codenerdette Gaming Hub is your ultimate destination for gaming entertainment and community.</p>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#">Terms of Service</a></li>
            <li><a href="#">Privacy Policy</a></li>
            <li><a href="#">Contact Us</a></li>
            <li><a href="#">Support</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Connect With Us</h4>
          <div className="social-links">
            <a href="#" title="Twitter"><i className="lni lni-twitter-original"></i></a>
            <a href="#" title="Discord"><i className="lni lni-discord"></i></a>
            <a href="#" title="Github"><i className="lni lni-github-original"></i></a>
            <a href="#" title="Instagram"><i className="lni lni-instagram-original"></i></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 Codenerdette Gaming Hub. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 